import React, { useEffect } from 'react';
import './admin.css';

export default function ConfirmDialog({
  open,
  title,
  message,
  confirmLabel = 'Confirm',
  danger = false,
  busy = false,
  onConfirm,
  onCancel,
}) {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape' && !busy) onCancel();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, busy, onCancel]);

  if (!open) return null;

  return (
    <div
      className="adm-backdrop"
      onMouseDown={(e) => {
        if (e.target === e.currentTarget && !busy) onCancel();
      }}
    >
      <div className="adm-modal adm-modal-sm" role="alertdialog" aria-modal="true" aria-labelledby="adm-confirm-title">
        <div className="adm-confirm-body">
          <span className={`adm-confirm-icon${danger ? ' is-danger' : ''}`}>
            <i className={`bi ${danger ? 'bi-exclamation-triangle' : 'bi-question-circle'}`} />
          </span>
          <div>
            <h2 id="adm-confirm-title" className="adm-modal-title">
              {title}
            </h2>
            <p className="adm-confirm-text">{message}</p>
          </div>
        </div>
        <div className="adm-modal-foot">
          <button type="button" className="adm-btn" onClick={onCancel} disabled={busy}>
            Cancel
          </button>
          <button
            type="button"
            className={`adm-btn ${danger ? 'adm-btn-danger' : 'adm-btn-primary'}`}
            onClick={onConfirm}
            disabled={busy}
          >
            {busy ? 'Working…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
